export const set = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const get = (key: string) => {
  const item = localStorage.getItem(key)
  if (!item) return null
  return JSON.parse(item)
}

export const remove = (key: string) => {
  localStorage.removeItem(key)
}
